export enum TrendIconsEnum {
    ContagemRegressiva = 'icon_explosion',
    QuedaLivre = 'icon_anchor',
    RetornoParaBaixa = 'icon_ricochet_down',
    DisparoDeAlta = 'icon_rocket',
    RetornoParaAlta = 'icon_ricochet_up',
    Congestionamento = 'icon_undefined',
    TendenciaSubindo = 'icon_trending_up',
    TendenciaCaindo = 'icon_trending_down',
    TendenciaNeutra = 'icon_undefined_line'
}